/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseError } from './BaseError';
const RateLimitExceededExceptionParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['retryAfter', parsers.duration, 'retry_after'],
]), BaseError);
export class RateLimitExceededException extends BaseError {
    static decode(input) {
        return RateLimitExceededExceptionParser.decode(input).map(res => new RateLimitExceededException(res));
    }
    static unsafeDecode(input) {
        return RateLimitExceededException.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RateLimitExceededExceptionParser.encode(data);
    }
    static schema() {
        return RateLimitExceededExceptionParser.schema();
    }
}
